import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { PageQueryService } from 'src/app/services/page-query.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
    selector: 'app-info-view',
    templateUrl: './info-view.component.html',
    styleUrls: ['./info-view.component.scss']
})
export class InfoViewComponent implements OnInit, OnDestroy {

    constructor(
        public pageQuery: PageQueryService,
        public loading: LoadingService,
        private http: HttpService
    ) { }
    private apiPath = 'infos';
    data: any = {};
    util = UtilitiesService;

    getData(): void {
        const query: any = this.pageQuery.query.getValue() || {};
        query.limit = query?.limit || 20;
        query.page = query?.page || 1;
        this.http.Get(this.apiPath, query).then((r: any) => {
            if (r.success) {
                this.data = r?.response?.result || {};
            }
        });
    }

    ngOnInit(): void {
        if (this.pageQuery.queryPage.limit < 20) {
            this.pageQuery.queryPage.limit = 20;
        }
        this.loading.start();
        this.pageQuery.init(() => {
            this.getData();
        });
    }

    ngOnDestroy(): void {
        this.pageQuery.destroy();
    }
}
